import { IonAlert, IonButton, IonCol } from '@ionic/react';
import React from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import AmountPaid from '../../components/amountPaid';
import Box, { BoxHeader } from '../../components/box';
import { NormalText, SmallText, Spacer, StrongText, Title } from '../../components/common';
import Layout from '../../components/layout';
import OrderContent from '../../components/orderContent';
import Loading from '../../components/spinner';
import Basket, { createNewBasketInstance } from '../../lib/basket';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import { forwardTo, isEmptyObject, visaEndingDrawText } from '../../lib/utils';
import { showToast } from '../../store/actions';
import { checkCancelOrder, setOrdersProp } from '../../store/orders/actions';
import './index.css';
import api from '../../lib/api';
import OrderStatus from '../../components/orderStatus';
import { ReactComponent as LocationIcon } from '../../assets/images/distance.svg';
import { ReactComponent as TimeIcon } from '../../assets/images/acute.svg';
import { ReactComponent as TableIcon } from '../../assets/images/picnic-table.svg';
import { ReactComponent as Repeat } from '../../assets/images/reorder.svg';

class HistoryDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isCancel: false,
			orderId: null,
			restaurantId: null,
			orderData: null,
		};
	}

	async componentDidMount() {
		const { location } = this.props;
		let orderData = null;
		if (location?.state?.order?.has_multi_basket && !location?.state?.order?.is_gift && !location?.state?.order?.is_event) {
			orderData = await api.getMultiVenueOrder({ order_id: location.state.order.id });
		} else {
			orderData = location?.state?.order;
		}
		if (orderData) {
			this.setState({ orderData }, () => {
				const now = moment();
				let cutoffTime = orderData ? orderData.cutoff_time : now;
				let cutoffTimeMoment = new moment(cutoffTime, 'YYYY-MM-DD HH:mm:ss');
				const utcOffset = cutoffTimeMoment.utcOffset();
				cutoffTimeMoment = cutoffTimeMoment.add('minutes', utcOffset);
				if (now.isBefore(cutoffTimeMoment)) {
					if (orderData.status !== 'REFUNDED') {
						this.setState({
							isCancel: true,
							orderId: orderData.id,
							restaurantId: orderData.restaurant_id,
						});
					}
				}
			});
		}
	}

	backHandler = () => {
		this.setState({ orderId: null, isCancel: false, restaurantId: null });
		forwardTo('/history', { tab: 'order' });
	};

	formatPaymentString = (str) => {
		let splitedStr = str.split(' ').splice(2).join(' ');
		return splitedStr;
	};

	cancelOrder = () => {
		const { orderId, isCancel, restaurantId } = this.state;
		if (isCancel) {
			this.props.dispatch(checkCancelOrder(orderId, restaurantId));
			this.setState({ orderId: null, isCancel: false, restaurantId: null });
		}
	};

	handleCancelOrderModal = (flag) => {
		this.props.dispatch(setOrdersProp('cancelOrderModal', flag));
	};

	drawContentTitle = (__, deliveryOption, id, orderType) => {
		if (orderType === 'Outpost Drop-Off') {
			return (
				<Title className='web-only page-title-centered'>
					{__('Drop Point')} {__('Order')} #{id}
				</Title>
			);
		} else if (orderType === 'Delivery') {
			return (
				<Title className='web-only page-title-centered' >
					{__('Delivery')} {__('Order')} #{id}
				</Title>
			);
		} else if (orderType === 'Table') {
			return (
				<Title className='web-only page-title-centered'>
					{__('At Table')} {__('Order')} #{id}
				</Title>
			);
		} else if (orderType === 'pick-up-at-counter') {
			return (
				<Title className='web-only page-title-centered'>
					{__('Pickup at Counter')} #{id}
				</Title>
			);
		} else {
			return (
				<Title className='web-only page-title-centered'>
					{__('Order')} #{id}
				</Title>
			);
		}
	};
	orderAgain = () => {
		const selectedRestaurant = this.props.restaurants.filter((restaurant) => restaurant.id === this.state.orderData.restaurant_id);
		if (selectedRestaurant.length > 0) {
			Basket.reset();
			let orderLabel = Basket.getOrderType(this.state.orderData);
			let option = (getConfig().delivery || []).find((d) => d.id === orderLabel);
			Basket.setDeliveryOption(option);
			forwardTo(option.route, { selectedRestaurant: this.state.orderData,reorder:true });
		} else {
			this.props.dispatch(showToast('This restaurant is no longer receiving orders.', 'warning'));
		}
	};

	drawContent = (__, order, orderType, basketInstance, status) => {
		if (!order?.is_gift && !order?.is_event) {
			if (orderType === 'Click & Collect') {
				return (
					<>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div><StrongText className='text-to-update'>{__('Collection details')}</StrongText></div>
							<div className="order-status-wrapper">
								<div>{status && __(status)}</div>
							</div>
						</div>
						<Spacer size={2} />
						<div className="box-content order-content-details">
							<>
								{!order.has_multi_basket && (
									<div>
										<LocationIcon className='fill-label' />
										<StrongText className="block text-to-update">{order.restaurant_name}</StrongText>

									</div>
								)}
								<div>
									<TimeIcon className='fill-label' />{' '}
									<NormalText className="block">
										{__('Collection time')}
									</NormalText>
									<NormalText className="block">{order.is_asap ? this.props.__('ASAP') : basketInstance.formatOrderTime(this.props.__, true, 'Do MMM h:mm a')}</NormalText>
								</div>


							</>
						</div>
					</>
				);
			} else if (orderType === 'Delivery') {
				return (
					<>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div><StrongText className='text-to-update'>{__('Order details')}</StrongText></div>
							<div className="order-status-wrapper">
								<div>{status && __(status)}</div>
							</div>
						</div>
						<Spacer size={2} />

						<div className="box-content order-content-details">
							{!order.has_multi_basket && (
								<div>
									<LocationIcon className='fill-label' />
									<StrongText className="block text-to-update">{order.restaurant_name}</StrongText>
								</div>
							)}
							<div>
								<TimeIcon className='fill-label' />
								<NormalText className="block">
									{__('Delivery time')}
								</NormalText>
								<NormalText className="block">{order.is_asap ? this.props.__('ASAP') : basketInstance.formatOrderTime(this.props.__, true, 'Do MMM h:mm a')}</NormalText>
							</div>
							<Spacer size={2} />
							<div style={{ alignItems: 'flex-start' }}>
								<LocationIcon className='fill-label' />
								<div>

									<NormalText className="block">
										{__('Delivery to')}
									</NormalText>
									<NormalText className="block">{[order.delivery_address?.addressLine1, order.delivery_address?.addressLine2, order.delivery_address?.place, order.delivery_address?.postalCode].filter(Boolean).join(', ')}</NormalText>
								</div>
							</div>

						</div>
					</>
				);
			} else if (orderType === 'Outpost Drop-Off') {
				return (
					<>
						<div className="box-content order-content-details">
							<div>
								{!order.has_multi_basket && (
									<>
										<StrongText>{__('Drop-off at')}</StrongText>
										<StrongText className="block text-to-update">{order.restaurant_name}</StrongText>
									</>
								)}
								<SmallText className="block">
									{__('Order placed on')}: {moment(order.created_at).format('Do MMM h:mm a')}
								</SmallText>
								<SmallText className="block">
									{__('Drop-off Time')}: {basketInstance.formatOrderTime(this.props.__, true)}
								</SmallText>
							</div>
							<div className="order-status-wrapper">
								<div>{status && __(status)}</div>
							</div>
						</div>
					</>
				);
			} else if (orderType === 'Table') {
				return (
					<>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div><StrongText className='text-to-update'>{__('Order table details')}</StrongText></div>
							<div className="order-status-wrapper">
								<div>{status && __(status)}</div>
							</div>
						</div>
						<Spacer size={2} />

						<div className="box-content order-content-details">
							{!order.has_multi_basket && (
								<div>
									<LocationIcon className='fill-label' />
									<StrongText className="block text-to-update">{order.restaurant_name}</StrongText>
								</div>
							)}
							<div>
								<TableIcon className='fill-label' />
								<NormalText className="block">
									{__('Table Number')}
								</NormalText>
								<NormalText className="block">{order.table_name}</NormalText>
							</div>


						</div>
					</>
				);
			} else if (orderType === 'scheduled-collection') {
				return (
					<>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div><StrongText className='text-to-update'>{__('Order details')}</StrongText></div>
							<div className="order-status-wrapper">
								<div>{status && __(status)}</div>
							</div>
						</div>
						<Spacer size={2} />

						<div className="box-content order-content-details">
							{!order.has_multi_basket && (
								<div>
									<LocationIcon className='fill-label' />
									<StrongText className="block text-to-update">{order.restaurant_name}</StrongText>
								</div>
							)}
							<div>
								<TimeIcon className='fill-label' />{' '}
								<NormalText className="block">
									{__('Collection time')}
								</NormalText>
								<NormalText>
									{basketInstance.additional_data?.named_time_slots_data ? (
										<>
											{basketInstance.formatOrderTime(this.props.__, true, 'DD MMM YYYY')} {__('at')} {basketInstance.additional_data?.named_time_slots_data}
										</>
									) : (
										<>
											{basketInstance.formatOrderTime(this.props.__, true, 'Do MMM h:mm a')}
										</>
									)}
								</NormalText>
							</div>

						</div>
					</>
				);
			} else if (orderType === 'pick-up-at-counter') {
				return (
					<>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div><StrongText className='text-to-update'>{__('Order details')}</StrongText></div>
							<div className="order-status-wrapper">
								<div>{status && __(status)}</div>
							</div>
						</div>
						<Spacer size={2} />

						<div className="box-content order-content-details">
							{!order.has_multi_basket && (
								<div>
									<LocationIcon className='fill-label' />
									<StrongText className="block text-to-update">{order.restaurant_name}</StrongText>
								</div>
							)}
							<div>
								<TimeIcon className='fill-label' />
								<NormalText className="block">
									{__('Collection time')}
								</NormalText>
								<NormalText className="block">{__('ASAP')}</NormalText>
							</div>



						</div>
					</>
				);
			} else if (orderType === 'scheduled-delivery') {
				return (
					<>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div><StrongText className='text-to-update'>{__('Order details')}</StrongText></div>
							<div className="order-status-wrapper">
								<div>{status && __(status)}</div>
							</div>
						</div>
						<Spacer size={2} />

						<div className="box-content order-content-details">
							{!order.has_multi_basket && (
								<div>
									<LocationIcon className='fill-label' />
									<StrongText className="block text-to-update">{order.restaurant_name}</StrongText>
								</div>
							)}
							<div>
								<TimeIcon className='fill-label' />
								<NormalText className="block">
									{__('Delivery time')}
								</NormalText>
								<NormalText className="block">{basketInstance.formatOrderTime(this.props.__, true, 'Do MMM h:mm a')}</NormalText>
							</div>
							<Spacer size={2} />
							<div style={{ alignItems: 'flex-start' }}>
								<LocationIcon className='fill-label' />
								<div>
									<NormalText className="block">
										{__('Delivery to')}
									</NormalText>
									<NormalText className="block">{[order.delivery_address?.addressLine1, order.delivery_address?.addressLine2, order.delivery_address?.place, order.delivery_address?.postalCode].filter(Boolean).join(', ')}</NormalText>
								</div>
							</div>

						</div>
					</>
				);
			}
		} else {
			return <></>;
		}
	};

	render() {
		const { __, cards } = this.props;
		const order = this.state.orderData;
		if (order) {
			const { id } = order;
			const basketInstance = createNewBasketInstance();
			basketInstance.recreateOrder(order);
			const orderType = basketInstance.getOrderType();
			const orderCompletePage = false;
			let paymentMetod = basketInstance.formatPaymentMethod(this.props.cards, __, orderCompletePage);
			const orderTypeTitle = basketInstance.getOrderType() === 'Click & Collect' ? 'Collection' : basketInstance.getOrderType();
			const hasCancelOrder = getConfig().appType.hasCancelOrder;
			const headerLabel = `${__('Order')} ${`#${id}`}`;
			const status = getConfig().flags.removeOrderStatus ? null : order?.status
			const restaurantMenuItemImage = order?.menu_item_placeholder_image || null
			return (
				<Loading>
					<Layout title={headerLabel} headerWithTitle={true} color="transparent" backHandler={this.backHandler}>
						<div className="absolute-content history-details">
							<div className="scrollable-y">
								<>
									{this.drawContentTitle(__, Basket.getDeliveryOption(), id, orderTypeTitle)}
									<>
										{order?.additional_data?.uber?.error &&
											<div className='invalid-uber-order'>
												<StrongText>{order.additional_data.uber.error.message}</StrongText>
												<Spacer size={0} />
												{Object.values(order.additional_data.uber.error.metadata).map((el, index) => (
													<NormalText key={`uber-order_${index}`}>{el}</NormalText>
												))}
												<Spacer size={0} />

												<NormalText>{__('Please contact support.')}</NormalText>

											</div>
										}

										{this.drawContent(__, order, orderType, basketInstance, status)}
										<Spacer size={5} />

										<OrderContent restaurantMenuItemImage={restaurantMenuItemImage} basketInstance={basketInstance} type="orderHistory" />
										{!order.is_gift && !order.is_event && order.events.length > 0 && getConfig().flags.hasOrderStatus && (
											<>
												<Spacer size={5} />
												<OrderStatus events={order.events} />
												<Spacer size={5} />
											</>
										)}
										<AmountPaid order={order} cards={this.props.cards} />
									</>

								</>

								<div>
									{!order.is_gift && !order.is_event && !Basket.has_multi_basket && (
										<>
											<IonButton color="primary" expand="block" fill="solid" onClick={() => this.orderAgain()} className="reorder-btn button-uppercase">
												{getConfig().flags.hasIconOnReorder &&
													<Repeat />
												}

												{__('Repeat this order')}
											</IonButton>
										</>

									)}
								</div>
							</div>
						</div>
					</Layout>
					<IonAlert
						isOpen={this.props.cancelOrderModal === true}
						onDidDismiss={() => this.handleCancelOrderModal(false)}
						header={__('Confirm')}
						message={__('Do you want to cancel this order?')}
						buttons={[
							{
								text: __('Remove'),
								handler: () => this.cancelOrder(),
								cssClass: 'primary'
							},
							{
								text: __('Cancel'),
								role: 'cancel',
								cssClass: 'secondary link',
							},

						]}
					/>
				</Loading>
			);
		} else {
			return (
				<Loading>
					<Layout title={__('Order')} headerWithTitle={true} color="transparent" backHandler={this.backHandler}></Layout>
				</Loading>
			);
		}
	}
}

const mapStateToProps = (store) => {
	const orders = store.orders;
	const { cancelOrderModal } = orders;
	const { restaurants } = store.restaurants;
	let lastOrder = null;
	const orderHistory = orders.orderHistory;
	if (orderHistory && orderHistory.length > 0) {
		lastOrder = orderHistory[0];
	}
	return {
		cards: orders.cards || [],
		lastOrder,
		restaurants: restaurants || [],
		cancelOrderModal,
	};
};

export default connect(mapStateToProps)(withTranslation(HistoryDetails));
